var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowright(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.8525 11.6029L10.6025 4.85286C10.7091 4.7535 10.8502 4.69941 10.9959 4.70198C11.1416 4.70455 11.2807 4.76358 11.3837 4.86664C11.4868 4.9697 11.5458 5.10874 11.5484 5.25447C11.551 5.40019 11.4969 5.54123 11.3975 5.64786L5.60844 11.4379L20.75 11.4379C20.8992 11.4379 21.0423 11.4971 21.1477 11.6026C21.2532 11.7081 21.3125 11.8512 21.3125 12.0004C21.3125 12.1495 21.2532 12.2926 21.1477 12.3981C21.0423 12.5036 20.8992 12.5629 20.75 12.5629L5.60844 12.5629L11.3975 18.3529C11.4969 18.4595 11.551 18.6005 11.5484 18.7463C11.5458 18.892 11.4868 19.031 11.3837 19.1341C11.2807 19.2371 11.1416 19.2962 10.9959 19.2987C10.8502 19.3013 10.7091 19.2472 10.6025 19.1479L3.8525 12.3979C3.74716 12.2924 3.688 12.1494 3.688 12.0004C3.688 11.8513 3.74716 11.7083 3.8525 11.6029Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowright);
export default __webpack_public_path__ + "static/media/arrowright.cef68baa68d68dd2a6e0fa84ec2b1185.svg";
export { ForwardRef as ReactComponent };